export const GET_USERS = 'admin/auth/user/list';

export const POST_NOTIFICATION = 'admin/notification/pushNotification';

export const GET_NOTIFICATION = 'admin/notification/getNotification';

export const REJECT_NOTIFICATION = 'admin/auth/userReject';